import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IUploadArtifactPanelStyles {
  root?: IStyle;
}

export interface IUploadArtifactPanelClassNames {
  root: string;
}

export const uploadArtifactPanelStylesDefault = (_theme: IH2OTheme): Partial<IUploadArtifactPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
